import { axiosInstance } from '.'
import { CREATE_FAQ_V1, DELETE_FAQ_V1, GET_FAQS_V1, UPDATE_FAQ_V1 } from './endpoints'

export type FaqListResponse = {
  categories: {
    category: string | null
    items: {
      id: number
      question: string
      answer: string
      sort_order: number
    }[]
  }[]
}

export type FaqFlatRow = {
  id: number
  question: string
  answer: string
  category: string | null
  sort_order: number
}

export type FaqFormPayload = {
  question: string
  answer: string
  category: string | null
  sort_order: number
}

export const flattenFaqs = (data: FaqListResponse): FaqFlatRow[] =>
  data.categories.flatMap((g) =>
    g.items.map((it) => ({
      ...it,
      category: g.category,
    })),
  )

export const faqServices = {
  list: async (): Promise<FaqListResponse> => {
    const { data } = await axiosInstance.get<FaqListResponse>(GET_FAQS_V1)
    return data
  },

  create: async (payload: FaqFormPayload) => {
    return axiosInstance.post(CREATE_FAQ_V1, {
      question: payload.question,
      answer: payload.answer,
      category: payload.category,
      sort_order: payload.sort_order,
    })
  },

  update: async (id: number, payload: Partial<FaqFormPayload>) => {
    const body: Record<string, unknown> = {}
    if (payload.question !== undefined) body.question = payload.question
    if (payload.answer !== undefined) body.answer = payload.answer
    if (payload.category !== undefined) body.category = payload.category
    if (payload.sort_order !== undefined) body.sort_order = payload.sort_order
    return axiosInstance.patch(UPDATE_FAQ_V1(id), body)
  },

  remove: async (id: number) => {
    return axiosInstance.delete(DELETE_FAQ_V1(id))
  },
}
